import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import {
  Typography,
  Form,
  Input,
  InputNumber,
  Space,
  Select,
  Button,
  Card,
  Avatar,
  Badge,
  Image,
} from 'antd';
import { EditOutlined, MailOutlined, MobileOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../../hooks/useLocalStorage';

const { Title, Text } = Typography;
const { Meta } = Card;

export const Profile = () => {
  const [user, setUser] = useLocalStorage('user', null);
  const navigate = useNavigate();

  console.log(user);

  return (
    <>
      <div style={{ margin: '2rem auto', width: '100%', maxWidth: '600px' }}>
        <Space
          direction={window.innerWidth < 480 ? 'vertical' : 'horizontal'}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Space.Compact direction="vertical">
            <Title level={2} style={{ lineHeight: '0.2' }}>
              YOUR PROFILE
            </Title>
            <Title level={4} type="secondary" style={{ lineHeight: '0.2' }}>
              {user.realm} / {user.role}
            </Title>
          </Space.Compact>
          <Space align="center">
            <Button
              // icon={<Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />}
              onClick={() => navigate('change-password')}
            >
              Change password
            </Button>
            <Tooltip title="Edit Profile">
              <Button
                icon={
                  <Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />
                }
                onClick={() => navigate('update')}
              />
            </Tooltip>
          </Space>
        </Space>
        <Card
          style={{
            width: '100%',
            marginTop: '2rem',
          }}
        >
          <Meta
            avatar={
              <Avatar size={100}>
                {user.name
                  .split(' ') // Split the name into an array of words
                  .map(word => word.charAt(0)) // Get the first letter of each word
                  .join('')}
              </Avatar>
            }
            title={
              <Title level={4} style={{ lineHeight: '2.5' }}>
                {user.name}
              </Title>
            }
            description={
              <Space wrap>
                <Badge status="default" text={<Text type="secondary">{user.email}</Text>} />
                <Badge status="default" text={<Text type="secondary">{user.mobile}</Text>} />
                {/* <Text type='secondary'><Space align='center'><MailOutlined/>swamsuesha76@gmail.com</Space></Text>
                  <Text type='secondary'><Space align='center'><MobileOutlined/>O9984261387</Space></Text> */}
              </Space>
            }
          />
          {/* <Avatar size={100}>SH</Avatar>
          <Space>
            <Title>Swam Htet Aung</Title>
            <Text><MailOutlined />Swam Htet Aung</Text>
            <Text><MobileOutlined />Swam Htet Aung</Text>
          </Space> */}
        </Card>
      </div>
    </>
  );
};
